export enum ScheduledJobScriptType {
    Sh = "sh",
};

export const SCHEDULED_JOB_SCRIPT_TYPE_LABELS: { [key in ScheduledJobScriptType]: string } = {
    [ScheduledJobScriptType.Sh]: "Shell Executable",
};

export const SCHEDULED_JOB_SCRIPT_TYPES = [
    ScheduledJobScriptType.Sh,
] as const;
